import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner } from 'react-bootstrap';
import { userCanAccessPurchaseTabs } from '../constants/opportunityAccess';

interface PrivateRouteProps {
  children: React.ReactElement;
  allowedRoles?: string[];
  requirePurchaseTabsAccess?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  allowedRoles,
  requirePurchaseTabsAccess = false,
}) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="loading-spinner">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Carregando...</span>
        </Spinner>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && (!user?.role || !allowedRoles.includes(user.role))) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requirePurchaseTabsAccess && !userCanAccessPurchaseTabs(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;

















